import fp from 'lodash/fp';
import isEqual from 'lodash/isEqual';

export const propsChanged = (propKeys, props, nextProps, deepCompare = false) => {
  if (deepCompare) {
    for (const key of propKeys) {
      if (!isEqual(fp.get(key)(props), fp.get(key)(nextProps))) return true;
    }
  } else {
    for (const key of propKeys) {
      if (fp.get(key)(props) !== fp.get(key)(nextProps)) return true;
    }
  }
  return false;
};

export const splitName = fullName => {
  const nameArray = fullName ? fullName.split(' ') : [];
  if (nameArray.length < 2) {
    return null;
  }

  const givenName = nameArray.slice(0, -1).join(' ');
  const familyName = nameArray.slice(-1).join(' ');
  if (!givenName || !familyName) {
    return null;
  }

  return { givenName, familyName };
};

export const removeTeacherLastName = teacherName => {
  if (!teacherName) return '';

  const textArray = teacherName ? teacherName.split(' ') : [];
  const { length } = textArray;
  if (length < 2) {
    return '';
  }

  let name = '';
  textArray.forEach((text, index) => {
    if (
      (index === length - 1 && !text.startsWith('[')) ||
      (index === length - 2 && textArray[length - 1].startsWith('['))
    ) {
      return;
    }
    name += text + ' ';
  });

  return name;
};

export const isObject = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);



// WEBPACK FOOTER //
// ./src/utils/helperFunctions.js